import XhrRequestHandler from '../../lib/XhrRequestHandler';
import { Categoria, CategoriaJSON } from './Categoria';
export class CategoriaSystem {
    private readonly base = '/categorias';
    constructor(private requestHandler: XhrRequestHandler) {
    }

    async getCategoriaIdentifiedBy(id: string): Promise<Categoria> {
        const data = await this.requestHandler.get<CategoriaJSON>(`${this.base}/${id}`);
        return Categoria.fromJSON(data);
    }

    async getList(): Promise<Categoria[]> {
        const data = await this.requestHandler.get<CategoriaJSON[]>(`${this.base}`);
        return data.map((entity) => Categoria.fromJSON(entity))
    }

    async getListForDropdown(): Promise<Categoria[]> {
        const data = await this.requestHandler.get<CategoriaJSON[]>(`${this.base}/for-dropdown`);
        return data.map((entity) => Categoria.fromJSON(entity))
    }

    async getListForAutocomplete(searchKey: string): Promise<Categoria[]> {
        const data = await this.requestHandler.get<CategoriaJSON[]>(`${this.base}/for-autocomplete?searchKey=${searchKey}`);
        return data.map((entity) => Categoria.fromJSON(entity));
    }

    async save(entity: Categoria) {
        const data = entity.toJSON();
        const savedEntity = await this.requestHandler.post<CategoriaJSON, CategoriaJSON>(this.base, data);
        return Categoria.fromJSON(savedEntity);
    }

    getBaseUrlForDatagrid() {
        return this.requestHandler.requestUrl(`${this.base}/datagrid`)
    }

}

